import { Component, Input, OnInit } from '@angular/core';
import { IGetBookingsAirResponse } from "../../../../libraries/service/resources/booking/interfaces/IGetBookings";
import { Yii } from "../../../../libraries/interfaces/Yii";

class ItineraryChangeInformationWording {
  public total: string = Yii.t('wui-iqba-js', 'Total des tarifications:');
  public totalAfterAdd: string = Yii.t('wui-iqba-js', 'Total des tarifications après ajout:')
}

@Component({
  selector: 'app-itinerary-change-information',
  templateUrl: 'itinerary-change-information.component.html',
  styleUrls: ['itinerary-change-information.component.scss']
})
export class ItineraryChangeInformationComponent implements OnInit {
  @Input()
  public itineraryChangeInformation: IGetBookingsAirResponse;
  @Input()
  public addPrice: {cost: number, retail: number};

  public sectorTable: any[];
  public indexSeparation: number = -1;
  public itineraryChangeInformationWording: ItineraryChangeInformationWording = new ItineraryChangeInformationWording();
  public ngOnInit(): void {
    this.sectorTable = this.itineraryChangeInformation.sector;
    for (let i: number = 0; i <  this.sectorTable.length - 1; i++) {
      if (this.sectorTable[i]?.to?.airport?.code != this.itineraryChangeInformation?.to?.airport?.code) {
        const date1: Date = new Date( this.sectorTable[i + 1].begin);
        const date2: Date = new Date( this.sectorTable[i].end);
        this.sectorTable[i].durationStop = {
          minutes: ((date1.getTime() - date2.getTime()) / 1000) / 60,
        };
      } else {
        this.indexSeparation = i;
      }
    }
  }

  public getPriceAfterAdd(actualPrice: number): number {
    return (actualPrice + this.addPrice.cost);
  }

}
